const cardId = {
	card: {
		title: "Kartu",
		subtitle: "Ringkasan daftar kartu & topup",
		download_template: "Download Template",
		tabs: {
			list: "List Kartu",
			topup: "Topup",
		},
		list: {
			title: "Data Kartu",
			empty_state: {
				title: "Tidak ada data kartu",
				description: "Silakan tambahkan kartu baru.",
			},
			columns: {
				date: "Tanggal",
				card_no: "No Kartu",
				customer_name: "Nama Pelanggan / Akun",
				phone: "HP Pelanggan",
				card_name: "Nama pada Kartu",
				handphone: "Handphone",
				type: "Jenis Kartu",
				pin_default: "PIN Kartu Default",
				status: "Status",
				detail: "Detail",
			},
			status: {
				active: "Aktif",
				inactive: "Non Aktif",
				block: "Diblokir",
			},
		},
		topup: {
			title: "Data TopUp",
			empty_state: {
				title: "Tidak ada data topup",
				description: "Silakan lakukan topup kartu.",
			},
			columns: {
				date: "Tanggal",
				ref_id: "Ref ID",
				count_card: "Total Kartu",
				user: "User",
				amount: "Nominal",
				fee: "Biaya Admin",
				total: "Total",
				status: "Status",
				fee_status: "Status Biaya Admin",
			},
			card_unit: "Kartu",
			status: {
				paid: "Terbayar",
				unpaid: "Belum Terbayar",
			},
			batch_modal: {
				trigger: "Batch Topup",
				title: "Batch Topup",
				source_label: "Sumber Dana Cazhbox",
				source_placeholder: "Pilih sumber dana",
				source_loading: "Memuat sumber dana...",
				no_data: "Tidak Ada Data",
				dropzone_selected: "File dipilih: {name}",
				dropzone_empty: "Klik atau geser file ke sini",
				dropzone_hint: "Format: .xls, .xlsx (maks. 5MB)",
				cancel: "Batal",
				upload: "Upload",
				processing: "Memproses...",
				alert_select_file: "Pilih file terlebih dahulu!",
				alert_select_source: "Pilih sumber dana terlebih dahulu!",
				alert_success: "Batch topup berhasil diproses!",
				error_title: "Gagal memproses batch topup",
				error_description: "Terjadi kesalahan, silakan coba lagi.",
				success_title: "Berhasil",
				validation: {
					file_required: "File wajib diunggah",
					file_type: "File harus berformat .xls atau .xlsx",
					file_size: "Ukuran file maksimal 5MB",
					source_required: "Sumber dana wajib dipilih",
				},
			},
		},
		detail: {
			error_title: "Gagal memuat data kartu",
			error_description:
				"Terjadi kesalahan saat memuat detail kartu. Silakan coba lagi.",
			retry: "Coba Lagi",
			change_pin: "Ganti PIN",
			card_no: "No Kartu",
			identify_id: "Identify ID",
			card_type: "Jenis Kartu",
			card_version: "Versi Kartu",
			pin_activation: "Pin Kartu Aktivasi",
			last_change_pin: "Terakhir ganti PIN",
			campaign: "Campaign",
			wallets: "Wallets",
			user: "User",
			customer: "Customer",
			status: "Status",
			name: "Nama",
			email: "Email",
			phone_number: "Nomor Handphone",
			copy_success_title: "Berhasil",
			copy_card_no_success: "Berhasil copy No Kartu ke clipboard!",
			copy_identify_id_success: "Berhasil copy identify ID ke clipboard!",
			change_pin_modal: {
				title: "Ganti PIN",
				description: "Ganti Pin Baru",
				new_pin_label: "PIN Baru",
				cancel: "Batal",
				submit: "Ubah PIN",
				success_title: "PIN Diganti",
				success_description: "PIN telah diganti!",
				error_title: "Gagal",
				validation_length: "Pin harus 6 karakter",
				validation_number: "Pin harus berupa Nomor",
			},
			actions: {
				error_title: "Terjadi kesalahan!",
				error_description: "coba lagi beberapa saat",
				cancel: "Batal",
				ok: "OK",
				block: {
					trigger: "Blokir kartu ini",
					title: "Blokir Kartu",
					description: "Blokir Kartu ini",
					confirm_message: "Apakah anda yakin ingin memblokir kartu ini?",
					confirm: "Tetap Blokir",
					success_title: "Kartu Diblokir",
					success_description: "Berhasil blokir kartu!",
				},
				unblock: {
					trigger: "Buka Blokir kartu ini",
					title: "Buka Blokir Kartu",
					description: "Buka Blokir Kartu ini",
					confirm_message: "Apakah anda yakin ingin membuka blokir kartu ini?",
					confirm: "Buka Blokir Kartu",
					success_title: "Blokir Kartu Dibuka",
					success_description: "Berhasil buka blokir kartu!",
				},
				activate: {
					trigger: "Aktivasi kartu ini",
					title: "Aktivasi Kartu",
					description: "Aktivasi Kartu ini",
					submit: "Aktivasi",
					success_title: "Kartu Diaktivasi",
					success_description: "Berhasil aktivasi kartu!",
					name_label: "Nama",
					name_placeholder: "Masukkan nama pengguna kartu",
					phone_label: "No Telepon",
					phone_placeholder: "Masukkan no telepon pengguna kartu",
					pin_label: "PIN",
					validation: {
						name_required: "Nama Harus diisi",
						name_min: "Nama harus diisi minimal 3 karakter",
						phone_required: "No telepon harus diisi",
						phone_min: "No telepon harus diisi minimal 3 karakter",
						phone_number: "No telepon harus berupa angka",
						phone_invalid_format:
							"Format no telepon Indonesia tidak valid (cth. 08xx, 62xx, +62xx)",
						pin_length: "PIN harus diisi 6 dengan angka",
						pin_number: "PIN harus berupa angka",
					},
				},
			},
		},
		transaction: {
			title: "Riwayat Transaksi",
			empty_state: {
				title: "Tidak ada data transaksi",
				description: "Belum ada transaksi yang tercatat pada kartu ini.",
			},
			columns: {
				date: "Tanggal",
				ref_id: "Ref ID",
				location: "Lokasi",
				type: "Tipe",
				wallet: "Wallet",
				nominal: "Nominal",
				status: "Status",
			},
			status: {
				success: "Berhasil",
				failed: "Gagal",
			},
		},
		actions: {
			warning_title: "⚠️ Perhatian!",
			cancel: "Batal",
			ok: "OK",
			toasts: {
				failed_title: "Gagal!",
				success_title: "Berhasil",
				error_title: "Terjadi kesalahan!",
				error_description: "coba lagi beberapa saat",
				select_reset_pin:
					"Harap check salah satu card yang ingin anda reset PIN!",
				success_reset_pin: "Berhasil reset PIN massal!",
				select_reset_user:
					"Harap check salah satu card yang ingin anda reset pengguna!",
				success_reset_user: "Berhasil reset pengguna massal!",
				select_block: "Harap check salah satu card yang ingin anda blokir!",
				success_block: "Berhasil blokir massal!",
				select_unblock:
					"Harap check salah satu card yang ingin anda buka blokir!",
				success_unblock: "Berhasil buka blokir massal!",
			},
			reset_pin: {
				label: "Reset PIN Kartu",
				message: "Apakah anda yakin untuk me-reset PIN kartu yang terpilih?",
			},
			reset_user: {
				label: "Reset Pengguna Kartu",
				message:
					"Apakah anda yakin untuk me-reset pengguna kartu yang terpilih?",
			},
			block: {
				label: "Blok Kartu",
				message: "Apakah anda yakin untuk memblokir kartu yang terpilih?",
			},
			unblock: {
				label: "Buka blok Kartu",
				message: "Apakah anda yakin untuk membuka blokir kartu yang terpilih?",
			},
		},
	},
};

export default cardId;
